import { camelizeObject, snakizeObject } from '@cvt/helpers/object';
import { format } from 'date-fns';


export const mapTributeData = (data: Tributes.TributeApi): Tributes.Tribute => {
  const tribute = camelizeObject<Tributes.Tribute>(data);
  return {
    ...tribute,
  };
};

export const mapTributeCrudData = (data: Tributes.Crud): Tributes.CrudApi => {
  const apiData: Tributes.CrudApi = snakizeObject(data);
  return {
    ...apiData,
    pet: {
      ...apiData.pet,
      passing_date: data.pet.passingDate && format(data.pet.passingDate, 'yyyy-MM-dd'),
      birthday: data.pet.birthday && format(data.pet.birthday, 'yyyy-MM-dd'),
    },
  };
};

export const mapParcelCrudData = (data: Tributes.ParcelCrud): Tributes.ParcelCrudApi => {
  const apiData: Tributes.ParcelCrudApi = snakizeObject(data);
  return {
    ...apiData,
  };
};

export const mapParcelData = (data: Tributes.ParcelApi): Tributes.Parcel => {
  const parcel = camelizeObject<Tributes.Parcel>(data);
  return {
    ...parcel,
  };
};
